export const STATEMENT = {
  STATEMENTS: 'STATEMENTS',
};
